import React, { useState } from 'react';
import { Drawer, Box, Typography, TextField, Button, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import workplaceService from '../services/workplace.service';

const modalTextFieldStyle = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '12px',
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2563EB',
        },
    },
    '& label.Mui-focused': {
        color: '#2563EB',
    },
};

const AddWorkplaceDrawer = ({ open, onClose, onWorkplaceCreated }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) {
            setError('Workplace name is required.');
            return;
        }
        setLoading(true);
        setError('');
        try {
            await workplaceService.createWorkplace(name);
            setLoading(false);
            setName('');
            onWorkplaceCreated();
        } catch (err) {
            setLoading(false);
            setError('Failed to create workplace. Please try again.');
            console.error(err);
        }
    };

    const handleClose = () => {
        setName('');
        setError('');
        onClose();
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={handleClose}
            keepMounted={false}
            disableRestoreFocus={true}
        >
            <Box sx={{ width: { xs: '100vw', sm: 400 }, p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>Add New Workplace</Typography>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    <Box sx={{ flexGrow: 1 }}>
                        <TextField
                            label="Workplace Name"
                            variant="outlined"
                            fullWidth
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            autoFocus
                            sx={{ ...modalTextFieldStyle, mb: 2 }}
                            error={!!error}
                            helperText={error}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, pt: 2 }}>
                        <Button onClick={handleClose} sx={{ color: 'grey.700', borderRadius: '12px' }}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={loading}
                            sx={{
                                bgcolor: '#2563EB',
                                color: 'white',
                                borderRadius: '12px',
                                boxShadow: 'none',
                                '&:hover': {
                                    bgcolor: '#1D4ED8',
                                    boxShadow: 'none',
                                },
                            }}
                        >
                            {loading ? <CircularProgress size={24} color="inherit" /> : 'Create'}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Drawer>
    );
};

export default AddWorkplaceDrawer; 